"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslation } from "@/app/i18n/client";
import { MultiSelect } from "@/components/ui/multi-select";
import { Control, FieldPath, FieldValues } from "react-hook-form";
import { api } from "@/utils/trpc/react";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { cn } from "@/lib/utils";
type Props<TFieldValues extends FieldValues, TFieldName extends FieldPath<TFieldValues>> = {
  control: Control<TFieldValues, TFieldName>;
  name: TFieldName;
  className?: string;
  visible?: boolean;
};
export function BusCompanyMultiSelect(t0) {
  const $ = _c(13);
  const {
    control,
    name,
    className,
    visible
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== visible) {
    t1 = {
      enabled: visible
    };
    $[0] = visible;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const companies = api.company.GetRegisteredCompanies.useQuery(undefined, t1);
  let t2;
  if ($[2] !== companies.data) {
    t2 = companies.data?.filter(_temp)?.map(_temp2) ?? [];
    $[2] = companies.data;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const options = t2;
  let t3;
  if ($[4] !== className || $[5] !== options || $[6] !== t || $[7] !== visible) {
    t3 = t4 => {
      const {
        field
      } = t4;
      return <FormItem className={cn(className, visible ? "block" : "hidden")}><FormLabel id="company-label">{t("DROPDOWNMENU.HEADER")}</FormLabel><FormControl><MultiSelect {...field} options={options} onValueChange={field.onChange} value={field.value} /></FormControl><FormMessage /></FormItem>;
    };
    $[4] = className;
    $[5] = options;
    $[6] = t;
    $[7] = visible;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== control || $[10] !== name || $[11] !== t3) {
    t4 = <FormField control={control} name={name} render={t3} />;
    $[9] = control;
    $[10] = name;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
function _temp2(c_0) {
  return {
    label: c_0.publicData.companyName,
    value: c_0.id
  };
}
function _temp(c) {
  return c.companyType === "busoperator";
}